module.exports = __webpack_public_path__ + "media/images/front/icon_data-73008971b78d42be3db80aa012f5279a.png";